import React from 'react'
import { Image } from '@shared/components/image'
import { Section } from '@shared/components/section'
import styled from 'styled-components'

export function SectionBanks(): JSX.Element {
	return (
		<Section>
			<ViewRoot>
				<a href='https://navigator.sk.ru/orn/1123861' target='_blank' rel='noopener noreferrer nofollow'>
					<ImageStyled name='investSk.png' alt='Участник Сколково' />
				</a>
			</ViewRoot>
		</Section>
	)
}

const ViewRoot = styled.div(({ theme }) => ({
	display: 'flex',
	marginLeft: 'auto',
	marginRight: 'auto',
	justifyContent: 'center',
	alignItems: 'center',
	flexDirection: 'column',
	marginBottom: 50,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		marginBottom: 100,
		flexDirection: 'row',
	},
}))

interface ImageStyledProps {
	last?: boolean
}
const ImageStyled = styled(Image)<ImageStyledProps>(({ last = false, theme }) => ({
	height: last ? 28 : 40,
	marginRight: 0,
	marginBottom: last ? 0 : 30,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		marginRight: last ? 0 : 48,
		marginBottom: 0,
	},
}))
